<template>
    <div>
        <vue-editor v-model="content"></vue-editor>
        <input :id="name" v-model="content" :name="name" type="hidden">
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
    props: {
        initialValue: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
    },
    components: {
        VueEditor
    },
    data() {
        return {
            content: null
        };
    },
    mounted() {
        this.content = this.initialValue
    }
};
</script>
